import { AdjustTerms, PairedSalesAnalysisFeature } from '@aloft/toolkit-shared';
import { Block, Button, Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';

import { countActiveFilters } from '../../../../components/FilterDrawer/countActiveFilters.ts';
import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { PairedSalesFormSchema } from '../../types.ts';
import { countActivePairCriteria } from '../../utils/countActivePairCriteria.ts';
import { isPairedSalesCustomAnalysisFeature } from '../../utils/isPairedSalesCustomAnalysisFeature.ts';

type Props = {
  term: PairedSalesAnalysisFeature;
  numResults: number;
  numProperties: number;
  isEditFiltersDisabled: boolean;
  onClickEditFilters: () => void;
};

export const PickPairHeader = ({
  term,
  numProperties,
  numResults,
  isEditFiltersDisabled,
  onClickEditFilters,
}: Props) => {
  const { watch } = useZodFormContext<PairedSalesFormSchema>();
  const filters = watch('search.filters');
  const pairCriteria = watch('search.pairCriteria');

  const numFilters = countActiveFilters(filters) + countActivePairCriteria(pairCriteria);
  const termLabel = isPairedSalesCustomAnalysisFeature(term)
    ? term.name
    : (AdjustTerms[term].label ?? term);

  return (
    <Flex gap="24px" paddingX="28px" height="100%" alignItems="center" paddingBottom="4px">
      <Flex flexDirection="column">
        <Typography variant="h1">{termLabel} Analysis</Typography>
        <Flex gap="6px" alignItems="center">
          {numProperties > 0 ? (
            <>
              <Typography variant="body1" __dangerDoNotUseSx={{ marginTop: '-4px' }}>{`${
                numResults === 100 ? 'Top' : ''
              } ${numResults.toLocaleString()} pairs from ${numProperties.toLocaleString()} properties`}</Typography>

              <Tooltip label="Displaying up to 100 pairs.  If the total exceeds 100, only the 100 most similar pairs will be shown.">
                <Flex cursor="pointer" alignItems="center">
                  <Icon icon="question" />
                </Flex>
              </Tooltip>
            </>
          ) : (
            <Block height="17px">
              <Typography variant="body1" __dangerDoNotUseSx={{ marginTop: '-4px' }}>
                No results
              </Typography>
            </Block>
          )}
        </Flex>
      </Flex>
      <Block>
        <Button
          icon="equalizer"
          size="md"
          variant="primary"
          text={`Filters (${numFilters})`}
          onClick={onClickEditFilters}
          disabled={isEditFiltersDisabled}
          __dangerDoNotUseSx={{ paddingX: '14px' }}
        />
      </Block>
    </Flex>
  );
};
